// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"8a362c62","703":"1ebfe517","850":"d52d59de","934":"74b51d5c","940":"89f52b3f"}[chunkId] + ".chunk.css";
};